export default function Apropos() {
    return (
        <div className="Apropos">
            <h2>A propos de nous</h2>
            <p>Pblooop</p>
        </div>
    );
}